var map = {
	"./Admin/admin.module": [
		"./src/app/Admin/admin.module.ts",
		"default~Admin-admin-module~Benutzerverwaltung-benutzerverwaltung-module~Plattform-plattform-module~T~9db237ba",
		"default~Admin-admin-module~Plattform-plattform-module",
		"Admin-admin-module"
	],
	"./Benutzerverwaltung/benutzerverwaltung.module": [
		"./src/app/Admin/Benutzerverwaltung/benutzerverwaltung.module.ts",
		"default~Admin-admin-module~Benutzerverwaltung-benutzerverwaltung-module~Plattform-plattform-module~T~9db237ba",
		"Benutzerverwaltung-benutzerverwaltung-module"
	],
	"./Frontpages/Main/main.module": [
		"./src/app/Frontpages/Main/main.module.ts",
		"Frontpages-Main-main-module"
	],
	"./Plattform/plattform.module": [
		"./src/app/Plattform/plattform.module.ts",
		"default~Admin-admin-module~Benutzerverwaltung-benutzerverwaltung-module~Plattform-plattform-module~T~9db237ba",
		"default~Admin-admin-module~Plattform-plattform-module",
		"Plattform-plattform-module"
	],
	"./Tools/BackpackCmsModule/backpackcms.module": [
		"./src/app/Admin/Tools/BackpackCmsModule/backpackcms.module.ts",
		"Tools-BackpackCmsModule-backpackcms-module"
	],
	"./Tools/CompassStringsCMS/compass-cms.module": [
		"./src/app/Admin/Tools/CompassStringsCMS/compass-cms.module.ts",
		"Tools-CompassStringsCMS-compass-cms-module"
	],
	"./Tools/DBAResultShifter/dba-result-shifter.module": [
		"./src/app/Admin/Tools/DBAResultShifter/dba-result-shifter.module.ts",
		"Tools-DBAResultShifter-dba-result-shifter-module"
	],
	"./Tools/DigitalBackpack/backpack.module": [
		"./src/app/Plattform/Tools/DigitalBackpack/backpack.module.ts",
		"Tools-DigitalBackpack-backpack-module"
	],
	"./Tools/TransformationCompass/compass.module": [
		"./src/app/Plattform/Tools/TransformationCompass/compass.module.ts",
		"default~Admin-admin-module~Benutzerverwaltung-benutzerverwaltung-module~Plattform-plattform-module~T~9db237ba",
		"Tools-TransformationCompass-compass-module"
	],
	"./Tools/UserVerwaltung/user-verwaltung.module": [
		"./src/app/Admin/Tools/UserVerwaltung/user-verwaltung.module.ts",
		"Tools-UserVerwaltung-user-verwaltung-module"
	],
	"./Tools/transformation-compass-cms/transformation-compass-cms.module": [
		"./src/app/Admin/Tools/transformation-compass-cms/transformation-compass-cms.module.ts",
		"default~Admin-admin-module~Benutzerverwaltung-benutzerverwaltung-module~Plattform-plattform-module~T~9db237ba",
		"Tools-transformation-compass-cms-transformation-compass-cms-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;